<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">
        {{ 'DIALOG.ASSIGN.LABEL' | translate }} {{ 'DIALOG.ASSIGN.RESOURCE' | translate }}
      </h3>
    </div>
  </div>
  <div class="card-body">
    <form [formGroup]="form" class="form form-group mb-0">
      <mat-form-field appearance="fill" class="w-100 mb-5">
        <mat-label>{{ data.workflowGroup }} Workflow</mat-label>
        <mat-select required formControlName="workflowId">
          <mat-option *ngFor="let workflow of data.workflows" [value]="workflow.id">{{
            workflow.name
          }}</mat-option>
        </mat-select>
        <mat-hint>Select a workflow first</mat-hint>
        <mat-error *ngIf="isInvalid('workflowId')">{{
          getErrorMessage(data.workflowGroup + ' Workflow')
        }}</mat-error>
      </mat-form-field>
      <kt-add-process-nav-resource
        [templateId]="form.get('workflowId')?.value"
        [templateType]="TemplateType.WORKFLOW"
        [emitResources]="emitResources"
        (addedResources)="updateResources($event)"
      ></kt-add-process-nav-resource>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      type="button"
      mat-raised-button
      cdkFocusInitial
      style="width: 75px"
      class="mr-4"
      (click)="cancel($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      style="width: 75px"
      (click)="save($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
